// extracted by mini-css-extract-plugin
export var phone = "_1h-0";
export var phoneDragging = "_1h-1";